var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.53 36.7286V40.2764C79.5252 48.5924 76.8324 56.684 71.8532 63.3445C66.874 70.005 59.8751 74.8776 51.9004 77.2355C43.9258 79.5933 35.4025 79.3102 27.6019 76.4283C19.8013 73.5463 13.1412 68.22 8.61504 61.2437C4.08885 54.2674 1.93902 46.0149 2.48618 37.717C3.03334 29.4191 6.24818 21.5203 11.6512 15.1987C17.0543 8.87718 24.3561 4.47152 32.4676 2.63884C40.5791 0.806152 49.0657 1.64463 56.6617 5.02922M79.53 9.42548L40.9663 48.0277L29.3972 36.4586",
    stroke: "#26617D",
    strokeWidth: 2.89228,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.bcb15d88ad81d8406fb41bf1ad85d344.svg";
export { ForwardRef as ReactComponent };